import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CmsPageGuard, PageLayoutComponent, FormErrorsModule } from '@spartacus/storefront';
import { DatePickerModule } from 'primeng/datepicker';
import { ShipmentsComponent } from './shipments.component';
import { AuthGuard, CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { PageTitle } from '../store-front/misc/page-title/page-title.component';
import { TabOptionsComponent } from '../../../components/tab-options/tab-options.component';
import { LocalLoaderComponent } from '../../../components/loader/local-loader/local-loader.component';
import { TableProComponent } from '../../../components/table-pro/table-pro.component';
import { RouterModule } from '@angular/router';
import { ShipmentsService } from './core/shipments.service';
import { ShipmentsAdapter } from './core/shipments.adapter';
import { shipmentsOccConfig } from './core/shipments.occ';
import { AllowedKeysToDatePickerModule } from '../../../core/directives/allowed-keys-to-date-picker/allowed-keys-to-date-picker.module';

@NgModule({
  declarations: [ShipmentsComponent],
  imports: [
    CommonModule,
    DatePickerModule,
    ReactiveFormsModule,
    FormErrorsModule,
    PageTitle,
    I18nModule,
    TabOptionsComponent,
    LocalLoaderComponent,
    TableProComponent,
    AllowedKeysToDatePickerModule,
    RouterModule.forChild([
      {
        path: 'my-account/shipments',
        component: PageLayoutComponent,
        data: { pageLabel: 'my-account/shipments' },
        canActivate: [CmsPageGuard, AuthGuard],
      },
    ]),
  ],
  providers: [
    ShipmentsService,
    ShipmentsAdapter,
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShipmentsPageComponent: {
          component: ShipmentsComponent,
        },
      },
    }),
    provideConfig(shipmentsOccConfig),
    provideConfig({
      routing: {
        routes: {
          shipmentsPage: { paths: ['my-account/shipments'] },
        },
      },
    }),
  ],
})
export class ShipmentsModule {}
